import React, { memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { CategoryLandingPageSectionBlokProps } from './CategoryLandingPage';
import Heading from '../Heading/Heading';
import { HeadingTypes } from '../Heading/Heading';
import CategoryLandingPageSideBarDesktopList from './CategoryLandingPageSideBarDesktopList';
import CategoryLandingBarSideBarMobileDropdown from './CategoryLandingBarSideBarMobileDropdown';
import { useMediaQuery } from 'react-responsive';

interface CategoryLandingPageSideBarProps {
  categoryListTitle: string;
  categoryLandingPageSections: CategoryLandingPageSectionBlokProps[];
  activeCategoryLandingPageSection: string;
  setActiveCategoryLandingPageSection: (state: string) => void;
  categoryLandingHeight: number;
}

const CategoryLandingPageSideBar: React.FC<CategoryLandingPageSideBarProps> = ({
  categoryListTitle,
  categoryLandingPageSections,
  activeCategoryLandingPageSection,
  setActiveCategoryLandingPageSection,
  categoryLandingHeight,
}) => {
  const sm = useMediaQuery({
    query: '(max-width: 639px)',
  });
  const desktop = useMediaQuery({
    query: '(min-width: 640px)',
  });

  return (
    <aside className="relative space-y-4 h-full xl:space-y-0">
      <div className="text-center xl:text-left xl:pr-6 xl:hidden">
        <Heading
          text={categoryListTitle}
          headingType={HeadingTypes.h2}
          headingStyleType={HeadingTypes.h3}
        />
      </div>

      <div className="relative pb-12 z-10 xl:hidden">
        <div
          className={`absolute top-0 right-0 left-0 pointer-events-none`}
          style={{ minHeight: `${categoryLandingHeight}px` }}
        >
          <div
            className={`sticky ${
              desktop ? 'top-[7.4rem]' : 'top-0'
            } py-4 bg-surface/background`}
          >
            <CategoryLandingBarSideBarMobileDropdown
              categoryLandingPageSections={categoryLandingPageSections}
              activeCategoryLandingPageSectionName={
                activeCategoryLandingPageSection
              }
              setActiveCategoryLandingPageSection={
                setActiveCategoryLandingPageSection
              }
            />
          </div>
        </div>
      </div>

      {/*-- xl upwards --*/}
      <div className="hidden xl:block xl:sticky xl:top-40">
        <div className="text-center xl:text-left xl:pr-6 xl:pb-10">
          <Heading
            text={categoryListTitle}
            headingType={HeadingTypes.h2}
            headingStyleType={HeadingTypes.h3}
          />
        </div>
        <ul>
          <CategoryLandingPageSideBarDesktopList
            categoryLandingPageSections={categoryLandingPageSections}
            activeCategoryLandingPageSection={activeCategoryLandingPageSection}
          />
        </ul>
      </div>
    </aside>
  );
};

export default withBlokWrapper(CategoryLandingPageSideBar, Theme.LIGHT);
